import { c as _c } from "react/compiler-runtime";
import { classNames, FlexColumn, Separator } from "@opensea/ui-kit";
import { useFormContext, useWatch } from "react-hook-form";
import { useSwapContext } from "../../provider/SwapContext";
import { SwapWarning } from "./SwapWarning";
export function SwapWarnings() {
  const $ = _c(19);
  const {
    variant
  } = useSwapContext();
  const {
    control
  } = useFormContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["fromCurrency", "toCurrency"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== control) {
    t1 = {
      control,
      name: t0
    };
    $[1] = control;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [fromCurrency, toCurrency] = useWatch(t1);
  const tokensAreTheSame = !!toCurrency && fromCurrency.contractAddress === toCurrency.contractAddress && fromCurrency.chainIdentifier === toCurrency.chainIdentifier;
  const toCurrencyHasWarnings = toCurrency && toCurrency.warnings.length > 0;
  const hasWarnings = fromCurrency.warnings.length > 0 || toCurrencyHasWarnings;
  if (!hasWarnings) {
    return null;
  }
  const t2 = variant === "default";
  const t3 = variant === "frosted";
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = classNames("mt-4 rounded-md border", {
      "border-border-1 bg-bg-app": t2,
      "border-frosted-2 bg-frosted-1": t3
    });
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = fromCurrency.symbol;
  let t6;
  if ($[6] !== fromCurrency.warnings) {
    t6 = fromCurrency.warnings.map(_temp);
    $[6] = fromCurrency.warnings;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== fromCurrency.symbol || $[9] !== t6) {
    t7 = <SwapWarning symbol={t5} warnings={t6} />;
    $[8] = fromCurrency.symbol;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== toCurrency || $[12] !== toCurrencyHasWarnings || $[13] !== tokensAreTheSame) {
    t8 = !tokensAreTheSame && toCurrencyHasWarnings && <><div className="px-4"><Separator /></div><SwapWarning symbol={toCurrency.symbol} warnings={toCurrency.warnings.map(_temp2)} /></>;
    $[11] = toCurrency;
    $[12] = toCurrencyHasWarnings;
    $[13] = tokensAreTheSame;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t7 || $[17] !== t8) {
    t9 = <FlexColumn className={t4}>{t7}{t8}</FlexColumn>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}
function _temp2(w_0) {
  return w_0.featureId;
}
function _temp(w) {
  return w.featureId;
}